// import { Navigate, useLocation } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import AuthService from "./Components/auth/AuthService";
// import { RolePermissions } from './Components/common/Constants';

// const Auth = new AuthService();

// const matchPath = (pattern, path) => {
//   const patternSegments = pattern.split('/').filter(Boolean);
//   const pathSegments = path.split('/').filter(Boolean);

//   // Early return if segment lengths don't match and no wildcard
//   if (patternSegments.length !== pathSegments.length) {
//     return false;
//   }

//   for (let i = 0; i < patternSegments.length; i++) {
//     const p = patternSegments[i];
//     const s = pathSegments[i];

//     if (p.startsWith(':')) continue; 
//     if (p !== s) return false;   
//   }

//   return true;
// };


// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = Auth.loggedIn();
//   const location = useLocation();
//   const path = location.pathname;

//   const { type, roles } = useSelector((state) => state.AppState.userCreds);

//   if (!isAuthenticated) return <Navigate to="/" />;

//   // Admin/Manager roles see everything
//   if (type === 0 || type === 1) return children;

//   // Gather allowed routes from user roles
//   const roleIds = roles?.map(r => r.role_id);
//   let allowedRoutes = [];

//   roleIds?.forEach(roleId => {
//     if (RolePermissions[roleId]) {
//       allowedRoutes.push(...RolePermissions[roleId]);
//     }
//   });

//   // Check access with simple matching
//   const hasAccess = allowedRoutes.some((pattern) => matchPath(pattern, path));

//   return hasAccess ? children : <Navigate to="/dashboard" />;
// };

// export default ProtectedRoute;







import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AuthService from "./Components/auth/AuthService";
import { RolePermissions } from './Components/common/Constants';

const Auth = new AuthService();

const matchPath = (pattern, path) => {
  const patternSegments = pattern.split('/').filter(Boolean);
  const pathSegments = path.split('/').filter(Boolean);

  if (patternSegments.length !== pathSegments.length) return false;

  for (let i = 0; i < patternSegments.length; i++) {
    const p = patternSegments[i];
    const s = pathSegments[i];

    if (p.startsWith(':')) continue;
    if (p !== s) return false;
  }

  return true;
};

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = Auth.loggedIn();
  const location = useLocation();
  const path = location.pathname;

  const { type, roles } = useSelector((state) => state.AppState.userCreds);

  const accessPin = localStorage.getItem("access_pin");
  const hasRole5 = roles?.some(r => r.role_id === 5);


  // 1️⃣ Not logged in → go to login
if (!isAuthenticated) return <Navigate to="/" />;

if (path === "/") return <Navigate to="/dashboard" />;
// 2️⃣ Admin or Manager → allow everything without pin
if (type === 0 || type === 1 || (type === 2 && !hasRole5) ) return children;

// if (type === 2 && roles?.some(r => r.role_id != 5)) {
//     return children;
//   }

// 3️⃣ For others, check pin
if (!accessPin) return <Navigate to="/pin" />;

  // Gather allowed routes from roles
  const roleIds = roles?.map(r => r.role_id);
  let allowedRoutes = [];

  roleIds?.forEach(roleId => {
    if (RolePermissions[roleId]) {
      allowedRoutes.push(...RolePermissions[roleId]);
    }
  });

  // Check access
  const hasAccess = allowedRoutes.some((pattern) => matchPath(pattern, path));

  return hasAccess ? children : <Navigate to="/dashboard" />;
};

export default ProtectedRoute;
